<template>
  <div :class="[$style.benefits, 'section container']">
    <div>
      <div :class="$style.label">{{ t('referral.benefits.upperTitle') }}</div>
      <h2 :class="[$style.title, 'h2']">{{ t('referral.benefits.title') }}</h2>

      <div :class="$style.caption">{{ t('referral.benefits.caption') }}</div>
    </div>
    <div :class="$style.list">
      <div
        v-for="(item, index) of benefits"
        :key="index"
        :class="$style.item"
      >
        <div :class="$style.itemContent">
          <div :class="$style.itemTitle">{{ item.title }}</div>
          {{ item.caption }}
        </div>

        <div :class="$style.itemIcon">
          <component :is="item.Icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface BenefitsItem {
  title: string,
  caption: string,
  Icon: any,
}

const { t } = useI18n();

const rate = resolveComponent('UiIconsSale');
const pay = resolveComponent('UiIconsPayouts');
const guarentee = resolveComponent('UiIconsGuarantee');

const benefits = computed<BenefitsItem[]>(() => [
  {
    title: t('referral.benefits.tiles.1.title'),
    caption: t('referral.benefits.tiles.1.caption'),
    Icon: rate,
  }, {
    title: t('referral.benefits.tiles.2.title'),
    caption: t('referral.benefits.tiles.2.caption'),
    Icon: pay,
  }, {
    title: t('referral.benefits.tiles.3.title'),
    caption: t('referral.benefits.tiles.3.caption'),
    Icon: guarentee,
  },
]);
</script>

<style lang="scss" module>
  .benefits {
    display: flex;
    gap: 26px;

    @media (max-width: 767px) {
      flex-direction: column;
    }

    > div {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }

  .label {
    margin-bottom: 26px;
    color: #71787F;
  }

  .caption {
    max-width: 510px;
  }

  .title {
    margin-bottom: auto;

    @media (max-width: 767px) {
      margin-bottom: 22px;
    }
  }

  .item {
    display: flex;
    align-items: center;
    gap: 26px;
    padding: 29px 30px 28px 46px;
    border-radius: 24px;
    background: #FBFCFF;

    @media (max-width: 1023px) {
      padding: 15px 24px;
    }

    &Title {
      color: #121E29;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;

      @media (max-width: 1023px) {
        font-size: 16px;
      }
    }

    &Content {
      display: flex;
      flex-direction: column;
      gap: 9px;
    }

    &Icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 51px;
      height: 51px;
      margin-left: auto;
      flex-shrink: 0;
      fill: #F4F4F4;
      backdrop-filter: blur(7.5px);
      color: #293EFF;

      svg {
        height: 23px;
        width: auto;
      }
    }
  }
</style>